/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'left': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M12.364 27.583l21.024 21.055c1.223 1.15 3.096 1.15 4.248 0 1.152-1.15 1.152-3.09 0-4.24L18.7 25.5 37.636 6.601c1.152-1.22 1.152-3.09 0-4.239-1.152-1.15-3.025-1.15-4.248 0L12.364 23.344c-1.152 1.22-1.152 3.09 0 4.24z" _fill="#8C95A1" fill-rule="evenodd"/>'
  }
})
